// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3H0EN","question":"Question_question__3BJtu","description":"Question_description__2wJLJ"};